import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, DialogContent, DialogTitle, InfoPanel, Spinner } from '@otcmarketsgroup/otcm-ui-lib';
import { warnings } from '../../constants';
import { testIds } from '../../constants/testIds';

const SubmitInProgressDialog = ({ open, isError }) => {
    return (
        <Dialog open={open} data-testid={testIds.submitProgressDialog}>
            <DialogTitle title='Submitting' hideClose />
            <DialogContent>
                {isError ? <InfoPanel isError title={warnings.FAILED_SUBMIT} /> : <>
                    <InfoPanel isWarning title={warnings.DO_NOT_REFRESH} />
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: "12px 0" }}>
                        <Spinner />
                    </Box>
                </>}
            </DialogContent>
        </Dialog>
    );
};

SubmitInProgressDialog.propTypes = {
    open: PropTypes.bool
};

export default SubmitInProgressDialog;
